<template>
    <card :to="to" :absolute-target="absoluteTarget" v-bind="cardProps" xs-tight small
		  :style="!flat ? {borderTop: `2px solid ${event.color ?? $config.public.colors.primary} !important`} : null">
        <card-image :src="thumbnail" :size="imageSize" :alt="event.display_name">
			<div>
				<chip v-if="event.status && [eventStatus.Draft, eventStatus.Canceled].includes(event.status.value)" :color="event.status.color" class="absolute bottom-0 left-0 mb-8 ml-8 sm:ml-14 max-w-4/5" small>
					{{ event.status.title}}
				</chip>
				<chip v-else-if="event.is_private" color="warning" class="absolute bottom-0 left-0 mb-8 ml-8 sm:ml-14 max-w-4/5" small>
					{{ $t('label.private') }}
				</chip>
			</div>
        </card-image>

        <div class="h-88 px-16 flex-grow-1 flex flex-column justify-center">
            <sport-type-text class="text-2xs leading-tight mb-3" :sport-types="event.sportTypes" truncate>
                <meta-text v-if="event.type" :color="event.color ?? 'primary'">{{ event.type.title }}</meta-text>
            </sport-type-text>

            <p class="font-heading text-sm leading-tight font-bold text-heading-color mb-4 truncate">{{ event.display_name  }}</p>

            <div class="flex justify-between">
                <div class="flex flex-column overflow-hidden">
                    <p class="text-xs font-heading mb-2 truncate leading-tight text-text-color">
                        {{ $date(event.start_date).formatDateRange(event.end_date) }}
                    </p>
                    <p class="flex text-2xs font-heading mb-0 leading-tight overflow-hidden">
                        <span v-if="event.city" class="truncate">{{ event.city }}</span>
                        <span v-if="!event.country_code || event.country_code === 'ww'" class="whitespace-no-wrap">{{ $t('label.worldwide') }}</span>
                        <span v-else class="whitespace-no-wrap">{{ event.city ? ', ' : '' }}{{ event.country_code.toUpperCase() }}</span>
                    </p>
                </div>

                <div v-if="(event.labels && event.labels.length) || event.attendance_mode > 1" class="flex">
                    <tooltip v-if="event.attendance_mode > 1" :text="$t('help.event.virtual')" top>
                        <Icon :icon="icons.virtual" x-small color="gray-300" />
                    </tooltip>
                    <template v-if="event.labels && event.labels.length">
                    <template v-for="(label, key) in event.labels" :key="key">
                        <tooltip top :text="label.participant_description">
                            <div class="flex items-center justify-center ml-4">
                                <cdn-image :src="label.icon" :size="{height: 16, ratio: 719/865}" :alt="label.title"/>
                            </div>
                        </tooltip>
                    </template>
                    </template>
                </div>
            </div>
        </div>
    </card>
</template>

<script>
import {mdiBookmark, mdiCellphoneNfc, mdiGiftOutline} from '@mdi/js'

    import CardMixin from "../../Card/CardMixin";
    import Linkable from "../../../mixins/Linkable";
    import {EventStatus} from "@spoferan/spoferan-ts-core";
    import {getEventAvatarThumbnail} from "@spoferan/spoferan-ts-core";

    export default {
        name: 'EventCard',

        mixins: [Linkable, CardMixin],

        props: {
            event: {
                type: Object,
                required: true
            },

            imageSize: {
                type: Object,
                default: () => {return {width: 320, ratio: 3/2}}
            }

        },

        data() {
            return {
                eventStatus: EventStatus,
                icons: {
                    bookmark: mdiBookmark,
                    recommendation: mdiGiftOutline,
                    virtual: mdiCellphoneNfc,
                }
            }
        },

        computed: {
            thumbnail() {
                return getEventAvatarThumbnail(this.event)
            }
        }
    }
</script>